import styled from 'styled-components';
import { ButtonBase, default700, fontWeightBold } from 'lib/mortar';
import { IconChevronLeft } from '../Icons';
import { colorTextLinkHover } from '../../design-tokens';
import { Icon as BaseIcon } from 'lib/mortar';

const StyledBackButton = styled(ButtonBase)`
  padding: 0;
  color: ${default700};
  font-weight: ${fontWeightBold};
  ${BaseIcon} {
    svg,
    svg path {
      fill: ${default700};
    }
  }
  &:hover {
    color: ${colorTextLinkHover};
    ${BaseIcon} {
      svg,
      svg path {
        fill: ${colorTextLinkHover};
      }
    }
  }
`;

export const BackButton = ({
  text = 'Back',
  ...rest
}: {
  text?: string;
  [key: string]: any;
}) => (
  <StyledBackButton Icon={IconChevronLeft} {...rest}>
    {text}
  </StyledBackButton>
);
